import { render, staticRenderFns } from "./PickDetail.vue?vue&type=template&id=b5918eb6&"
import script from "./PickDetail.vue?vue&type=script&lang=ts&"
export * from "./PickDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PickDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports